function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { NumberSearchQueryField } from '../number-search-query-field';
export class Page extends NumberSearchQueryField {
  constructor(searchOptions, value) {
    super(searchOptions, value, 1);
    _defineProperty(this, "urlSlug", Page.urlSlug);
  }
  static fromUrlParameters(searchOptions, q) {
    return new Page(searchOptions, NumberSearchQueryField.parse(q[Page.urlSlug]));
  }
}
_defineProperty(Page, "urlSlug", 'page');